export default [
  {
    path: "/events",
    name: "events",
    component: () => import("@/views/events/Events.vue"),
    meta: { Permission: "view_events_menu" },
  },
  {
    path: "/events/add",
    name: "event-add",
    component: () => import("@/views/events/EventAdd.vue"),
    meta: { Permission: "create_event" },
  },
  {
    path: "/events/edit/:id",
    name: "event-edit",
    component: () => import("@/views/events/EventEdit.vue"),
    meta: { Permission: "edit_event" },
  },
  {
    path: "/events/duplicate/:id",
    name: "event-duplicate",
    component: () => import("@/views/events/EventDuplicate.vue"),
    meta: { Permission: "duplicate_event" },
  },
  {
    path: "/events/view/:id",
    name: "event-view",
    component: () => import("@/views/events/EventView.vue"),
    meta: { Permission: "view_events_menu" },
  },
  {
    path: "/events/applications/:id",
    name: "event-applications",
    component: () => import("@/views/events/EventApplications.vue"),
    meta: { Permission: "view_event_applications" },
  },
  {
    path: "/events/attendance/:sessionId",
    name: "event-attendance",
    component: () => import("@/views/events/EventAttendance.vue"),
    meta: { Permission: "no_permission_required" },
  },
];
